// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Gx-z","tooltipWrapper":"Hx-z","icon":"Ix-z","tooltip":"Jx-z","content":"Kx-z"};